Ext.define('SA.VectorMapToolType', {
    constructor(name) {
        this.name = name;
    },

    getCursor() {
        return {clickInfo: 'help', clickPoint: 'pointer', dragPan: null, dragZoom: 'crosshair'}[this.getName()];
    },

    getName() {
        return this.name;
    },

    hasName(name) {
        return this.getName() === name;
    },

    isClickInfo() {
        return this.hasName('clickInfo');
    },

    isDragPan() {
        return this.hasName('dragPan');
    },

    isDragZoom() {
        return this.hasName('dragZoom');
    }
});